var _g, _path, _path2, _g2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSparkles(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 97,
    viewBox: "0 0 95 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "sparkles",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#sparkles_filter0_df_480_922)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.8792 22.6687C38.1296 21.5277 40.3397 21.5277 40.5901 22.6687C42.1279 29.6756 45.0744 39.8205 49.9315 44.6776C54.7886 49.5347 64.9335 52.4812 71.9405 54.019C73.0814 54.2694 73.0814 56.4796 71.9405 56.73C64.9335 58.2677 54.7886 61.2143 49.9315 66.0714C45.1479 70.8551 42.2174 80.7679 40.6608 87.7605C40.4056 88.907 38.1154 88.8982 37.8658 87.7504C36.3581 80.8166 33.4681 71.0018 28.5377 66.0714C23.6073 61.141 13.7925 58.251 6.85867 56.7433C5.71093 56.4938 5.70212 54.2036 6.84861 53.9483C13.8412 52.3917 23.754 49.4613 28.5377 44.6776C33.3948 39.8205 36.3414 29.6756 37.8792 22.6687Z",
    fill: "url(#sparkles_paint0_linear_480_922)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.8792 22.6687C38.1296 21.5277 40.3397 21.5277 40.5901 22.6687C42.1279 29.6756 45.0744 39.8205 49.9315 44.6776C54.7886 49.5347 64.9335 52.4812 71.9405 54.019C73.0814 54.2694 73.0814 56.4796 71.9405 56.73C64.9335 58.2677 54.7886 61.2143 49.9315 66.0714C45.1479 70.8551 42.2174 80.7679 40.6608 87.7605C40.4056 88.907 38.1154 88.8982 37.8658 87.7504C36.3581 80.8166 33.4681 71.0018 28.5377 66.0714C23.6073 61.141 13.7925 58.251 6.85867 56.7433C5.71093 56.4938 5.70212 54.2036 6.84861 53.9483C13.8412 52.3917 23.754 49.4613 28.5377 44.6776C33.3948 39.8205 36.3414 29.6756 37.8792 22.6687Z",
    fill: "url(#sparkles_paint1_linear_480_922)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.2346 23.4845C38.4608 26.9349 37.3544 31.0896 35.8543 35.0148C34.2946 39.0962 32.2524 43.0842 29.5984 45.7382C26.9837 48.3529 23.0754 50.3728 19.0618 51.9224C15.137 53.4377 10.9678 54.5568 7.49329 55.3411C7.49329 55.3415 7.49329 55.3419 7.49329 55.3424C7.4933 55.3439 7.49331 55.3453 7.49332 55.3468C10.9416 56.1079 15.0768 57.2065 18.992 58.7254C23.0001 60.2803 26.9147 62.3271 29.5984 65.0107C32.282 67.6944 34.3288 71.609 35.8837 75.6171C37.4026 79.5323 38.5012 83.6675 39.2623 87.1158C39.2638 87.1158 39.2652 87.1158 39.2667 87.1158C39.2672 87.1158 39.2676 87.1158 39.2681 87.1158C40.0524 83.6413 41.1714 79.4721 42.6867 75.5473C44.2363 71.5337 46.2562 67.6254 48.8709 65.0107C51.5249 62.3567 55.5129 60.3145 59.5943 58.7548C63.5195 57.2547 67.6742 56.1483 71.1246 55.3745C67.6742 54.6007 63.5195 53.4943 59.5943 51.9942C55.5129 50.4344 51.5249 48.3923 48.8709 45.7382C46.2169 43.0842 44.1747 39.0962 42.6149 35.0148C41.1149 31.0896 40.0084 26.9349 39.2346 23.4845ZM39.2346 20.313C40.1272 20.313 41.7033 20.7437 42.0552 22.3471C42.8154 25.8107 43.9176 30.0199 45.4172 33.9439C46.9295 37.9009 48.7891 41.4139 50.9922 43.6169C53.1953 45.82 56.7082 47.6796 60.6653 49.1919C64.5892 50.6915 68.7984 51.7938 72.262 52.5539C73.8654 52.9058 74.2962 54.4819 74.2962 55.3745C74.2962 56.267 73.8654 57.8432 72.262 58.1951C68.7984 58.9552 64.5892 60.0575 60.6653 61.5571C56.7082 63.0694 53.1953 64.929 50.9922 67.1321C48.8232 69.3011 46.986 72.7411 45.4853 76.6279C43.997 80.4828 42.8943 84.6303 42.1249 88.0864C41.9481 88.8809 41.4213 89.4122 40.8842 89.7129C40.3632 90.0045 39.7805 90.1177 39.2556 90.1158C38.7307 90.1139 38.1491 89.9963 37.6304 89.7014C37.096 89.3975 36.5728 88.8637 36.4 88.0692C35.6555 84.6452 34.5758 80.5401 33.0868 76.7022C31.5872 72.8368 29.7238 69.3788 27.4771 67.1321C25.2303 64.8853 21.7723 63.0219 17.9069 61.5223C14.069 60.0334 9.96386 58.9536 6.53995 58.2091C5.74537 58.0363 5.21161 57.5131 4.90773 56.9787C4.61283 56.46 4.49526 55.8785 4.49331 55.3535C4.49137 54.8287 4.60459 54.2459 4.89623 53.7249C5.19693 53.1878 5.72819 52.661 6.52268 52.4842C9.97877 51.7148 14.1263 50.6122 17.9812 49.1238C21.8681 47.6231 25.308 45.7859 27.4771 43.6169C29.6801 41.4139 31.5398 37.9009 33.052 33.9439C34.5516 30.0199 35.6539 25.8107 36.414 22.3471C36.7659 20.7437 38.3421 20.313 39.2346 20.313Z",
    fill: "black"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#sparkles_filter1_df_480_922)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.7813 5.85018C73.1036 4.72743 75.6083 4.72743 75.9306 5.85018C76.8621 9.09528 78.249 12.6085 80.2002 14.5597C82.1515 16.5109 85.6647 17.8978 88.9098 18.8293C90.0325 19.1516 90.0325 21.6563 88.9098 21.9786C85.6647 22.9102 82.1515 24.297 80.2002 26.2483C78.3126 28.1359 76.9531 31.4854 76.0231 34.6398C75.6909 35.7664 73.0613 35.7583 72.73 34.6314C71.8122 31.5092 70.4507 28.1873 68.5117 26.2483C66.5726 24.3092 63.2507 22.9478 60.1285 22.0299C59.0017 21.6986 58.9935 19.069 60.1201 18.7368C63.2745 17.8069 66.624 16.4474 68.5117 14.5597C70.4629 12.6085 71.8498 9.09528 72.7813 5.85018Z",
    fill: "url(#sparkles_paint2_linear_480_922)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7778 5.85012C73.1001 4.72739 75.605 4.72739 75.9273 5.85012C76.8586 9.09389 78.245 12.6052 80.1953 14.5556C82.1457 16.506 85.657 17.8923 88.9008 18.8236C90.0235 19.146 90.0235 21.6508 88.9008 21.9732C85.657 22.9044 82.1457 24.2908 80.1953 26.2412C78.3085 28.128 76.9496 31.4757 76.0198 34.6287C75.6876 35.7553 73.0578 35.7471 72.7265 34.6203C71.8088 31.4995 70.4479 28.1794 68.5097 26.2412C66.5716 24.303 63.2515 22.9421 60.1307 22.0245C59.0038 21.6931 58.9956 19.0633 60.1222 18.7311C63.2753 17.8014 66.6229 16.4424 68.5097 14.5556C70.4601 12.6052 71.8465 9.09389 72.7778 5.85012Z",
    fill: "url(#sparkles_paint3_linear_480_922)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.143 6.52794C73.2057 9.72437 71.7568 13.4298 69.5704 15.6163C67.4537 17.7329 63.9186 19.1548 60.811 20.091C60.8087 20.1008 60.8065 20.1111 60.8044 20.1219C60.7898 20.1958 60.7811 20.2821 60.7814 20.3739C60.7817 20.4657 60.7908 20.5522 60.8059 20.6264C60.8085 20.6393 60.8112 20.6514 60.8139 20.6627C63.9025 21.5914 67.4069 23.0171 69.5704 25.1805C71.7339 27.344 73.1595 30.8485 74.0882 33.937C74.0995 33.9398 74.1116 33.9425 74.1245 33.9451C74.1988 33.9602 74.2852 33.9693 74.377 33.9695C74.4688 33.9698 74.5551 33.9611 74.629 33.9466C74.6399 33.9444 74.6502 33.9422 74.6599 33.94C75.5961 30.8324 77.018 27.2972 79.1347 25.1805C81.3211 22.9941 85.0266 21.5453 88.223 20.608C88.2353 20.547 88.2429 20.4753 88.2429 20.3984C88.2429 20.3216 88.2353 20.2498 88.223 20.1888C85.0266 19.2516 81.3211 17.8027 79.1347 15.6163C76.9483 13.4298 75.4994 9.72437 74.5621 6.52794C74.5011 6.51565 74.4294 6.50809 74.3525 6.50809C74.2757 6.50809 74.204 6.51565 74.143 6.52794ZM88.1844 20.732C88.1844 20.7321 88.1846 20.7316 88.1852 20.7307L88.1844 20.732ZM76.0068 3.87273C76.539 4.13463 77.1364 4.6257 77.3691 5.43621C78.2973 8.66947 79.6021 11.8411 81.256 13.4949C82.9099 15.1488 86.0815 16.4536 89.3147 17.3819C90.1253 17.6146 90.6163 18.2119 90.8782 18.7441C91.1398 19.2756 91.2429 19.8649 91.2429 20.3984C91.2429 20.932 91.1398 21.5212 90.8782 22.0527C90.6163 22.5849 90.1253 23.1822 89.3147 23.4149C86.0815 24.3432 82.9099 25.648 81.256 27.3019C79.6594 28.8985 78.3835 31.9164 77.4586 35.053C77.2136 35.8836 76.5837 36.3681 76.0489 36.619C75.5087 36.8726 74.9102 36.9711 74.3686 36.9695C73.8269 36.968 73.2293 36.8661 72.6908 36.6105C72.1583 36.3576 71.5311 35.8722 71.2874 35.0434C70.3784 31.9519 69.101 28.9538 67.4491 27.3019C65.7972 25.65 62.7991 24.3726 59.7075 23.4636C58.8787 23.2199 58.3933 22.5927 58.1405 22.0601C57.8848 21.5216 57.7829 20.924 57.7814 20.3823C57.7799 19.8408 57.8784 19.2422 58.1319 18.702C58.3829 18.1672 58.8673 17.5373 59.698 17.2924C62.8345 16.3675 65.8524 15.0916 67.4491 13.4949C69.1029 11.8411 70.4077 8.66947 71.336 5.43621C71.5687 4.6257 72.166 4.13463 72.6983 3.87273C73.2297 3.61119 73.819 3.50809 74.3525 3.50809C74.8861 3.50809 75.4753 3.61119 76.0068 3.87273Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "sparkles_filter0_df_480_922",
    x: 0.993286,
    y: 16.813,
    width: 76.8029,
    height: 79.8029,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_480_922"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_480_922",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect2_foregroundBlur_480_922"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "sparkles_filter1_df_480_922",
    x: 54.2793,
    y: 0.00811768,
    width: 40.4725,
    height: 43.4726,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_480_922"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_480_922",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect2_foregroundBlur_480_922"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sparkles_paint0_linear_480_922",
    x1: 59.2913,
    y1: 35.3178,
    x2: 19.1779,
    y2: 75.4312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBF2C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEECB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sparkles_paint1_linear_480_922",
    x1: 59.2913,
    y1: 35.3178,
    x2: 19.1779,
    y2: 75.4312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBF2C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEECB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sparkles_paint2_linear_480_922",
    x1: 85.314,
    y1: 9.44595,
    x2: 63.3979,
    y2: 31.362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBF2C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEECB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sparkles_paint3_linear_480_922",
    x1: 85.3078,
    y1: 9.44315,
    x2: 63.3973,
    y2: 31.3537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBF2C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEECB5"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparkles);
export default __webpack_public_path__ + "static/media/sparkles.1c42b249add84965218eab3af11f84f4.svg";
export { ForwardRef as ReactComponent };